/** Fasen van de opbouwpagina. De foto's per fase komen uit de fotobibliotheek. */
export type OpbouwPhase = {
  id: string;
  short: string;
  title: string;
  description: string;
};

export const opbouwPhases: OpbouwPhase[] = [
  {
    id: "isolatie",
    short: "Isolatie",
    title: "Isolatie van de kuip",
    description:
      "De volledige kuip — bodem, wanden en trap — wordt bekleed met 3 cm dikke Recticel-isolatie. Ook de doorvoeren voor skimmers, inspuiters en verlichting worden netjes uitgesneden en afgedicht. Zo blijft de warmte in het water en niet in de grond.",
  },
  {
    id: "polyester",
    short: "Polyester",
    title: "Polyester bekleding aanbrengen",
    description:
      "Op de isolatie wordt laag per laag glasvezelmat met hars aangebracht: eerst de trap, dan de wanden en de bodem. Alles wordt naadloos in elkaar gelamineerd tot één waterdichte kuip, inclusief de doorvoeren voor verlichting en skimmers.",
  },
  {
    id: "schuren",
    short: "Schuren",
    title: "Schuren van de polyesterkuip",
    description:
      "Na de uitharding wordt de volledige kuip machinaal geschuurd en stofvrij gemaakt. Zo krijgt de afwerklaag een perfecte hechting op wanden, bodem en trap.",
  },
  {
    id: "topcoat",
    short: "Topcoat",
    title: "Topcoat in lichtgrijs",
    description:
      "De kuip krijgt zijn definitieve kleur met een slijtvaste, osmosebestendige topcoat. Trap, plage (zitbank), skimmers, inspuiters en verlichtingsnissen worden strak en naadloos afgewerkt.",
  },
  {
    id: "verlichting",
    short: "Verlichting",
    title: "Verlichting en inbouwdelen testen",
    description:
      "Alle inbouwdelen worden aangesloten en getest: de LED-kleurenverlichting in de nissen, de skimmers en de inspuiters. Alles moet perfect werken voor de werftent afgebroken wordt en de buitenwerken starten.",
  },
  {
    id: "open-lucht",
    short: "Open lucht",
    title: "Tent weg, kuip in open lucht",
    description:
      "De topcoat is uitgehard: de werftent wordt afgebroken en de kuip komt voor het eerst volledig in het zicht. Rondom wordt de werf klaargemaakt voor boordstenen, terras en de technische installatie.",
  },
  {
    id: "oplevering",
    short: "Oplevering",
    title: "Afdekking en oplevering",
    description:
      "De laatste stap: de zwembadafdekking wordt geplaatst, het bad wordt gevuld en het water wordt behandeld. Daarna volgt de definitieve oplevering aan de klant — klaar voor jaren zwemplezier.",
  },
  {
    id: "eindresultaat",
    short: "Eindresultaat",
    title: "Het eindresultaat, een seizoen later",
    description:
      "Zo ziet het project er een seizoen later uit: boordstenen gelegd, terras afgewerkt en het rolluik op zijn plaats. De geïsoleerde kuip en polyesterbekleding presteren nog even strak als op dag één.",
  },
];

export const opbouwPhaseNames = opbouwPhases.map((phase) => phase.short);
